import React, { useMemo } from 'react';
import uniqueId from 'lodash/uniqueId';
import cx from 'classnames';

import { RootPortal } from '../RootPortal';

import './Popover.scss';

export const Popover = ({ children, position = 'bottom', className, anchorName, style, popoverRef }) => {
  return (
    <RootPortal>
      <div
        ref={popoverRef}
        className={cx('app-popover', position, className)}
        style={{ positionAnchor: anchorName, ...style }}
        data-popover-anchor={anchorName}
      >
        {children}
      </div>
    </RootPortal>
  );
};

export const Wrapper = ({ children }) => {
  const anchorName = useMemo(() => uniqueId('--popover-anchor-'), []);

  return (
    <>
      <style>{`
        #root:has([data-wrapper-anchor="${anchorName}"]:hover) [data-popover-anchor="${anchorName}"],
        #root:has([data-popover-anchor="${anchorName}"]:hover) [data-popover-anchor="${anchorName}"] {
          display: block !important;
        }
      `}</style>
      <div className="app-popover-wrapper" style={{ anchorName }} data-wrapper-anchor={anchorName}>
        {React.Children.map(children, child =>
          React.isValidElement(child) ? React.cloneElement(child, { anchorName }) : child
        )}
      </div>
    </>
  );
};

Popover.Wrapper = Wrapper;
